const TAP_INTERVAL = 250; // tap interval in ms
const HANDLER_SINGLE_TAP = 'singleTap';
const HANDLER_DOUBLE_TAP = 'doubleTap';
const HANDLER_TRIPLE_TAP = 'tripleTap';

export default class MultiTapHandler {
	constructor(settings) {
		this.init(settings);
	}

	init({ tapInterval = TAP_INTERVAL, onSingleTap, onDoubleTap, onTripleTap }) {
		this.tapCount = 0;
		this.tapTimer = null;
		this.tapInterval = tapInterval;
		this.handlers = {
			[HANDLER_SINGLE_TAP]: onSingleTap,
			[HANDLER_DOUBLE_TAP]: onDoubleTap,
			[HANDLER_TRIPLE_TAP]: onTripleTap,
		};
	}

	setHandler(type, handler) {
		this.handlers[type] = handler;
	}

	handle(tapEvent) {
		this.tapCount++;

		if (!this.handlers[HANDLER_DOUBLE_TAP] && !this.handlers[HANDLER_TRIPLE_TAP]) {
			this.triggerNow(this.handlers[HANDLER_SINGLE_TAP]);
			return;
		}

		if (this.tapCount === 1) {
			this.triggerLater(this.handlers[HANDLER_SINGLE_TAP], tapEvent);
		} else if (this.tapCount === 2) {
			this.triggerLater(this.handlers[HANDLER_DOUBLE_TAP], tapEvent);
		} else if (this.tapCount >= 3) {
			this.triggerLater(this.handlers[HANDLER_TRIPLE_TAP], tapEvent);
		}
	}

	triggerLater(handler, e) {
		clearTimeout(this.tapTimer);
		if (!handler) {
			this.tapCount = 0;
			return;
		}

		this.tapTimer = setTimeout(() => {
			this.tapCount = 0;
			handler(e);
		}, this.tapInterval);
	}

	triggerNow(handler, e) {
		handler(e);
	}
}
